import api from './api';

// Student Management API calls
export const studentsService = {
  // Create new student
  createStudent: async (studentData) => {
    try {
      const response = await api.post('/api/students', studentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all students with filters
  getStudents: async (params = {}) => {
    try {
      // Map camelCase filters to backend snake_case and drop empty values
      const query = {};
      if (params.search) query.search = params.search;
      if (params.student_type) query.student_type = params.student_type;
      if (params.studentType) query.student_type = params.studentType; // Support both naming conventions
      if (params.age_group) query.age_group = params.age_group;
      if (params.ageGroup) query.age_group = params.ageGroup; // Support both naming conventions
      if (params.status) query.status = params.status; // only send if explicitly set
      if (params.lead_status) query.lead_status = params.lead_status; // for lead filtering
      // New filter parameters
      if (params.parent_name) query.parent_name = params.parent_name;
      if (params.country) query.country = params.country;
      if (params.timezone) query.timezone = params.timezone;
      if (params.batch_name) query.batch_name = params.batch_name;
      if (params.assignment_status) query.assignment_status = params.assignment_status;
      if (params.teacher_id) query.teacher_id = params.teacher_id;
      if (params.is_active !== undefined && params.is_active !== null) {
        // Send empty string for "All" option, 'true'/'false' for specific filters
        query.is_active = params.is_active === '' ? '' : params.is_active;
      }
      if (params.created_from) query.created_from = params.created_from;
      if (params.created_to) query.created_to = params.created_to;
      if (params.user_id) query.user_id = params.user_id;
      // Pagination
      if (params.page) query.page = params.page;
      if (params.limit) query.limit = params.limit;
      const response = await api.get('/api/students', { params: query });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get student by ID
  getStudent: async (id, params = {}) => {
    try {
      const response = await api.get(`/api/students/${id}`, {
        params: params.batchId ? { batchId: params.batchId } : undefined,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update student
  updateStudent: async (id, updateData) => {
    try {
      const response = await api.put(`/api/students/${id}`, updateData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete student
  deleteStudent: async (id) => {
    try {
      const response = await api.delete(`/api/students/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update student time preferences
  updateTimePreferences: async (id, timePreferences) => {
    try {
      const response = await api.put(`/api/students/${id}/time-preferences`, { timePreferences });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update student/lead status
  updateStatus: async (id, statusData) => {
    try {
      const response = await api.patch(`/api/students/${id}/status`, statusData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default studentsService; 